import React from 'react';
import { useSelector } from 'hooks/redux';
import PageHeader from '../../modules/page-header';
import { TabsContainer } from '@ru-digital-assets/ui-component';
import { FinTokens } from './fin-tokens';
import { IssuedTokens } from './issued-tokens';

const TABS = [
  {
    name: 'Денежные требования',
    id: 'fin-tokens',
    Component: FinTokens,
  },
  {
    name: 'Выпущенные ЦФА',
    id: 'issued-tokens',
    Component: IssuedTokens,
  },
];

const OPERATOR_TABS = [
  {
    name: 'Денежные требования',
    id: 'fin-tokens',
    Component: FinTokens,
  },
];

export const Assets: React.FC = () => {
  const position = useSelector((state) => state.auth.profile.position);
  const tabs = position === 'OPERATOR' ? OPERATOR_TABS : TABS;

  return (
    <div className="container">
      <div className="row">
        <div className="col-19S col-lg-27 col-xl-35">
          <PageHeader
            items={[{ link: '', title: 'Активы' }]}
            iconType="assets"
            isHideBalanceInformer={position === 'OPERATOR'}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-19S col-lg-27 col-xl-35">
          <TabsContainer tabs={tabs} activeBackgroundColor="#F8F9FA" />
        </div>
      </div>
    </div>
  );
};
